import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { StaticInfoContainerComponent } from '../static-info-container/static-info-container.component';
import { BehaviorSubject, Observable } from 'rxjs';
import { EmploymentHistory } from '../../../../models/users/dto/employment-history';
import { map } from 'rxjs/operators';
import { BaseInfoItem } from '../../../profile/models/base-info-item';
import { EmploymentStatusTypeId } from '../../../../models/employers/enum/employment-status-type-id';
import * as moment from 'moment';

@Component({
  selector: 'app-mp-profile-employer-history-static-info-container',
  templateUrl: './mp-profile-employer-history-static-info-container.component.html',
  styleUrls: [
    '../static-info-container/static-info-container.component.scss',
    '../../../profile/components/profile.component.scss',
    './mp-profile-employer-history-static-info-container.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MpProfileEmployerHistoryStaticInfoContainerComponent
  extends StaticInfoContainerComponent
  implements OnChanges
{
  @Input() employmentHistory!: EmploymentHistory;

  private _employmentHistory = new BehaviorSubject<EmploymentHistory | null>(null);
  public employmentHistory$ = this._employmentHistory as Observable<EmploymentHistory | null>;

  public items$ = this.employmentHistory$.pipe(
    map(eh => {
      const infoItems = [
        new BaseInfoItem($localize`Province of Employment`, eh?.provinceOfEmployment?.name ?? '-'),
        new BaseInfoItem($localize`Employment Start`, eh?.formattedStartDate ?? '-'),
        new BaseInfoItem($localize`Employment End`, eh?.formattedEndDate ?? '-'),
        new BaseInfoItem($localize`Employment Type`, eh?.employmentType?.name ?? '-'),
        new BaseInfoItem($localize`Work from Home`, eh?.workFromHome ? $localize`Yes` : $localize`No`),
        new BaseInfoItem($localize`Employment Status`, eh?.employmentStatus?.name ?? '-')
      ];
      if (eh?.employmentStatus.id === EmploymentStatusTypeId.Active) {
        infoItems.push(new BaseInfoItem($localize`On Leave`, eh?.onLeave ? $localize`Yes` : $localize`No`));
      }
      if (!!eh?.onLeave) {
        infoItems.push(new BaseInfoItem($localize`Leave Type`, eh?.leaveDetails?.leaveType?.name ?? '-'));
        infoItems.push(
          new BaseInfoItem(
            $localize`Leave Start`,
            eh?.leaveDetails?.startDate ? moment(eh?.leaveDetails?.startDate).format('MMM D, YYYY') : '-'
          )
        );
        infoItems.push(
          new BaseInfoItem(
            $localize`Expected Return`,
            eh?.leaveDetails?.expectedReturnDate
              ? moment(eh?.leaveDetails?.expectedReturnDate).format('MMM D, YYYY')
              : '-'
          )
        );
        infoItems.push(
          new BaseInfoItem(
            $localize`Continued Contributions`,
            eh?.leaveDetails?.continuedContributions ? $localize`Yes` : $localize`No`
          )
        );
      }
      return infoItems;
    })
  );

  public ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
    if (changes.employmentHistory) {
      this._employmentHistory.next(this.employmentHistory);
    }
  }
}
